import { h, Component } from 'preact';
import { Router } from 'preact-router';
import Home from './home/home';
import CampaignRedirect from './campaignRedirect/campaignRedirect';
import TradeCompliance from './trade/trade';
import Security from './trade/security';
import Terms from './trade/terms';
import Privacy from './trade/privacy';

let {
  pushState
} = history;
history.pushState = (a, b, url) => {
  pushState.call(history, a, b, url);
  scrollTo(0, 0);
};

export default class App extends Component {

  render() {
    return ( <div className = "app" >
      <Router>
        <Home path="/" />
        <TradeCompliance path="/trade" />
        <Security path="/security" />
        <Terms path="/terms" />
        <Privacy path="/privacy" />
        <CampaignRedirect path="/:campaignUid" />
      </Router>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./components/app.js